import axios from 'axios';

import AuthService from '../../state/auth.service';
import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    create(criterionId, userEmail, commentBody) {
        return axios
            .post(
                endpoints.CRITERION_BASE + '/' + criterionId + '/comment',
                {
                    user_email: userEmail,
                    body: commentBody,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Error getting comments for ...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    update(criterionId, commentId, commentBody) {
        return axios
            .put(
                endpoints.CRITERION_BASE +
                    '/' +
                    criterionId +
                    '/comment/' +
                    commentId,
                {
                    body: commentBody,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Error getting comments for ...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    remove(criterionId, commentId) {
        return axios
            .delete(
                `${endpoints.CRITERION_BASE}/${criterionId}/comment/${commentId}`,
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    getComments(criterionId) {
        return axios
            .get(endpoints.CRITERION_BASE + '/' + criterionId + '/comments', {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Error getting comments for ...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },
};
